export const productID = {
  HOME: 1,
  CASINO: 2,
  LOTTO: 3,
  SPORT: 4,
  LIVE_CASINO: 5,
  VIRTUALS: 7,
  WINNER_FUN: 8,
  CUSTOMER_SUPPORT: 9,
  ALL: 10000,
};

export const productMainURL = {
  HOME: '/',
  SPORT: '/sport/pre-match',
  CASINO: '/casino',
  LIVE_CASINO: '/live-casino',
  LOTTO: '/lotto',
  VIRTUALS: '/virtuals',
  WINNER_FUN: '/winnerfun',
  CUSTOMER_SUPPORT: '/profile/customer-support',
  ALL: '*',
};

const serverIDs: any = {};

// Product ID 1 = Slots
serverIDs[productID.CASINO] = 1;
serverIDs[productID.HOME] = 1;

// Product ID 2 = Betting
serverIDs[productID.SPORT] = 2;
serverIDs[productID.WINNER_FUN] = 2;

// Product ID 3 = Lotto
serverIDs[productID.LOTTO] = 3;

// Product ID 4 = Evolution
serverIDs[productID.LIVE_CASINO] = 4;

// No Product ID = All Products
serverIDs[productID.ALL] = 10000;

export const serverProductID = serverIDs;
